import { Link } from "react-router-dom";
import { Printer, Download, ArrowLeft, CheckCircle2, XCircle, Minus } from "lucide-react";

export const B = ({ t, cls = "text-ink font-semibold" }) => (
  <>
    {t.split(/(\*\*[^*]+\*\*)/g).map((s, i) =>
      s.startsWith("**") && s.endsWith("**")
        ? <strong key={i} className={cls}>{s.slice(2, -2)}</strong>
        : <span key={i}>{s}</span>
    )}
  </>
);

export const TierIcon = ({ tier }) =>
  tier === 1 ? <CheckCircle2 className="h-3.5 w-3.5 text-flame flex-shrink-0" />
  : tier === 3 ? <XCircle className="h-3.5 w-3.5 text-charcoal/40 flex-shrink-0" />
  : <Minus className="h-3.5 w-3.5 text-charcoal/40 flex-shrink-0" />;

export const CollateralBar = ({ product, label, pdf, testid }) => (
  <div className="sticky top-0 z-40 bg-ink text-white border-b border-white/10 print:hidden">
    <div className="max-w-6xl mx-auto px-6 h-14 flex items-center justify-between">
      <Link to={`/products/${product}`} className="inline-flex items-center gap-2 text-white/70 hover:text-flame text-sm">
        <ArrowLeft className="h-4 w-4" /> Back to product
      </Link>
      <div className="flex items-center gap-3">
        <span className="hidden sm:inline text-[11px] uppercase tracking-widest text-white/50">{label}</span>
        <a href={pdf} download data-testid={`download-${testid}`} className="inline-flex items-center gap-2 border border-white/25 text-white px-4 py-2 text-sm font-semibold hover:border-flame hover:text-flame transition-colors">
          <Download className="h-4 w-4" /> Download PDF
        </a>
        <button onClick={() => window.print()} data-testid={`print-${testid}`} className="inline-flex items-center gap-2 bg-flame text-white px-4 py-2 text-sm font-semibold hover:bg-flame/90 transition-colors">
          <Printer className="h-4 w-4" /> Print
        </button>
      </div>
    </div>
  </div>
);
